import type { ApiResponse } from '@/types/api';
import { AxiosError } from 'axios';

export async function apiHandler<T>(fn: () => Promise<T>): Promise<ApiResponse<T>> {
    try {
        const data = await fn();
        return {
            ok: true,
            data,
        };
    } catch (error) {
        const err = error as AxiosError<{ code?: string }, unknown>;

        const message =
            err.response?.data && typeof err.response.data === 'object'
                ? ((err.response.data as { message?: string })?.message ?? 'Unknown error')
                : (err.message ?? 'Unknown error');

        throw {
            ok: false,
            error: message,
            statusCode: err.response?.status,
            data: null,
            errorCode: err?.response?.data?.code,
        };
    }
}
